<template>
  <v-app>
    <core-drawer />

    <v-content class="overflow-hidden">
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
  export default {
    components: {
      CoreDrawer: () => import('@/components/core/Drawer'),
    },
  }
</script>

<style>
  .text-decoration-none {
    text-decoration: none;
  }
  #app {
    background-color: #000000;
  }
</style>
<style lang="scss">
  @import "./node_modules/vue-cookieconsent-component/src/scss/_cookie-consent.scss";
</style>
